import React, {Fragment} from "react";
import StepButton from "components/Step/StepButton";
import StepQuestion from "components/Step/StepQuestion";
import InboundFollowUpService from "services/Transaction/inbound/InboundFollowUpService";
import StepLoadingComponent from "components/Step/StepLoadingComponent";
import ToastHelper from "utils/ToastHelper";
import S3DocumentTypeEnum from "domain/S3DocumentTypeEnum";
import AdditionalDocumentsUploadStep from "views/Unauthenticated/Registerv2/Steps/AdditionalDocumentsUploadStep";
import RegisterV2 from "views/Unauthenticated/Registerv2/RegisterV2";
import * as QueryStringUtil from "utils/QueryStringUtil";
import InboundTransactionService from "../../../services/Transaction/inbound/InboundTransactionService";
import ReportingDeclarationService
    from "../../../services/Transaction/reporting.declaration/ReportingDeclarationService";
import ReportingDeclarationComponent from "../../../components/ReportingDeclarationComponent";
import {Input} from "reactstrap";

const StepKey = {
    START_STEP: "START_STEP",
    CAPTURE_DOCUMENTS: "CAPTURE_DOCUMENTS",
    REPORTING_DECLARATION: "REPORTING_DECLARATION",
    CONFIRMATION_STEP: "CONFIRMATION_STEP",
    FINAL: "FINAL",
}

export default class InboundFollowUpFlow extends React.Component {

    constructor(props, context) {

        super(props, context);

        this.token = QueryStringUtil.getQueryStringValue("t");

        this.state = {
            currentStep: StepKey.START_STEP,
            stepDirection: RegisterV2.FORWARD,
            loading: true,
            requirementIndex: 0,
            capturedDocuments: []
        }
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        InboundFollowUpService.retrieveByToken(this.token).then(response => {
            let newState = {loading: false};
            if (response.id) {
                newState.followUpResponse = response;
                let requirementsToCapture = [];
                response.requirements.forEach(singleRequirement => {
                    if (singleRequirement.status !== 'APPROVED') {
                        requirementsToCapture.push(singleRequirement);
                    }
                })
                newState.requirementsToCapture = requirementsToCapture;

                if(response.requiresSigningOfReportingDeclaration){
                ReportingDeclarationService.retrieveByVersion(response.reportingDeclarationVersion).then(reportingDeclaration => {
                    if (!reportingDeclaration.id) {
                        ToastHelper.formatError(reportingDeclaration);
                        this.setState(newState);
                    } else {
                        newState.reportingDeclaration = reportingDeclaration;
                        InboundTransactionService.retrieveByRedemptionId(response.redemptionRequestId).then(response => {
                            if (response.id) {
                                newState.transaction = response;
                            } else {
                                ToastHelper.formatError(response);
                            }
                            this.setState(newState);
                        })
                    }
                })
                }else{
                    InboundTransactionService.retrieveByRedemptionId(response.redemptionRequestId).then(response => {
                        if (response.id) {
                            newState.transaction = response;
                        } else {
                            ToastHelper.formatError(response);
                        }
                        this.setState(newState);
                    })
                }
            } else {
                ToastHelper.formatError(response);
                this.setState(newState);
            }

        })
    }

    nextStep(stepKey, newState) {
        this.setState({
            ...newState,
            currentStep: stepKey,
            stepDirection: RegisterV2.FORWARD
        })
    }

    backStep(previousStep) {
        this.setState({
            currentStep: previousStep,
            stepDirection: RegisterV2.BACKWARD
        });
    }

    onDocumentsUploaded(uploadedDocuments) {
        let newState = {
            capturedDocuments: uploadedDocuments
        }
        if (this.state.followUpResponse.requiresSigningOfReportingDeclaration) {
            this.nextStep(StepKey.REPORTING_DECLARATION, newState);
        } else {
            this.nextStep(StepKey.CONFIRMATION_STEP, newState);
        }
    }

    onReportingDeclarationSigned() {
        this.nextStep(StepKey.CONFIRMATION_STEP, this.state);
    }

    createSubmissionObject() {
        let capturedDocuments = [];
        this.state.followUpResponse.requirements.forEach(singleRequirement => {
            let documentPurpose = singleRequirement.documentPurpose
            if (singleRequirement.status === 'APPROVED') {
                capturedDocuments.push({
                    requirementId: singleRequirement.id,
                    metaDataId: singleRequirement.capturedDocument.metaDataId,
                    documentTypeId: singleRequirement.capturedDocument.documentTypeId
                })
            } else {
                capturedDocuments.push({
                    requirementId: singleRequirement.id,
                    metaDataId: this.state.capturedDocuments[documentPurpose]["additional-document-metadata-id"],
                    documentTypeId: this.state.capturedDocuments[documentPurpose]["document-type"].id
                })
            }

        })

        return {
            capturedDocuments: capturedDocuments,
            signedDeclaration: this.state.followUpResponse.requiresSigningOfReportingDeclaration ? this.state.signedDeclaration : false,
            declarationVersion: this.state.followUpResponse.requiresSigningOfReportingDeclaration ? this.state.reportingDeclaration.version : 0
        }
    }

    submitRequirements() {
        this.setState({loading: true})
        let submissionObject = this.createSubmissionObject();
        InboundFollowUpService.captureRequirements(this.state.followUpResponse.id, submissionObject).then((response) => {
            if (response.message) {
                this.setState({loading: false}, () => {
                    ToastHelper.formatError(response)
                });
            } else {
                this.setState({loading: false}, () => {
                    ToastHelper.success("Successfully submitted documents for approval")
                    this.nextStep(StepKey.FINAL)
                })
            }
        })
    }

    toggleAccept(event) {
        this.setState({
            signedDeclaration: event.target.checked
        })
    }

    render() {

        if (this.state.loading) {
            return <StepLoadingComponent/>
        }

        return <div className={"background"}>
            <div className={"step_content"}>
                <div className={"step_header"}>
                    <div className={"logo"}>
                        <img
                            src={'https://sfx-public-bucket.s3-eu-west-1.amazonaws.com/remittance-partner-logos/' + this.state.transaction.remittancePartner + '-PRIMARY.png'}
                            alt={''}
                        />
                    </div>
                </div>
                <div className={"step_card"}>
                    {this.renderContent()}
                </div>
            </div>
        </div>

    }

    renderContent() {
        if (this.state.followUpResponse === undefined) {
            return <Fragment>
                <StepQuestion>
                    An error occurred retrieving the follow up information.
                </StepQuestion>
            </Fragment>
        }
        if (this.state.followUpResponse.status !== 'PENDING_CUSTOMER') {
            return <Fragment>
                <StepQuestion>
                    It seems as though you have already submitted the required information.
                </StepQuestion>
            </Fragment>
        }
        if( this.state.transaction.inboundTransactionStatus !== 'UNALLOCATED') {
            return <Fragment>
                <StepQuestion>
                    It seems we no longer need this information.
                </StepQuestion>
            </Fragment>
        }
        return <Fragment>
            {this.renderStep(this.state.currentStep)}
        </Fragment>;
    }

    renderStep(currentStep) {
        switch (currentStep) {
            case StepKey.START_STEP:
                return this.renderStart();
            case StepKey.CAPTURE_DOCUMENTS:
                return this.renderCaptureDocumentsStep()
            case StepKey.REPORTING_DECLARATION:
                return this.renderReportingDeclarationStep()
            case StepKey.CONFIRMATION_STEP:
                return this.renderConfirmationStep()
            case StepKey.FINAL:
                return this.renderFinalStep()
            default:
                return <Fragment>Unknown step key "{this.state.currentStep}"</Fragment>
        }
    }

    renderStart() {
        return <Fragment>

            <StepQuestion>
                In order for us to pay out your transaction, you need to provide us with some additional documents.
            </StepQuestion>
            <StepQuestion>
                {this.state.followUpResponse.reason}
            </StepQuestion>
            <StepQuestion>
                Click "Start" to begin.
            </StepQuestion>

            <br/>
            <br/>
            <StepButton
                onClick={() => {
                    if (this.state.followUpResponse.requirements.length > 0) {
                        this.nextStep(StepKey.CAPTURE_DOCUMENTS);
                    } else {
                        this.nextStep(StepKey.REPORTING_DECLARATION);
                    }
                }}>
                Start
            </StepButton>


        </Fragment>
    }

    renderCaptureDocumentsStep() {
        return <Fragment>
            <AdditionalDocumentsUploadStep
                requiredDocuments={this.state.requirementsToCapture}
                additionalDocuments={this.state.capturedDocuments || []}
                documentPurposeKey={"documentPurpose"}
                documentPurposeDisplayValueKey={"documentPurposeDisplayValue"}
                stepDirection={this.state.stepDirection}
                onNextClick={(uploadedDocuments) => {
                    this.onDocumentsUploaded(uploadedDocuments)
                }}
                onBackClick={() => {
                    this.backStep(StepKey.START_STEP)
                }}
                s3DocumentType={S3DocumentTypeEnum.REGISTRATION_DOCUMENT}
            />
        </Fragment>
    }

    renderReportingDeclarationStep() {
        return <Fragment>
            <StepQuestion>
                Please read the terms and conditions and accept:
            </StepQuestion>
            <ReportingDeclarationComponent/>
            <div className={"step_declaration_accept"}>
                <Input style={{scale: "1.5"}}
                       onChange={this.toggleAccept.bind(this)}
                       type="checkbox"
                       checked={this.state.signedDeclaration}
                />
                <span>I accept and acknowledge the declaration</span>
            </div>
            <StepButton
                disabled={this.state.signedDeclaration !== true}
                onClick={this.onReportingDeclarationSigned.bind(this)}
            >
                Next
            </StepButton>
        </Fragment>
    }

    renderConfirmationStep() {
        return <Fragment>
            <StepQuestion>
                Thank you for providing us with your information.
                <br/>
                <br/>
                Click the submit button to submit your information for review.
            </StepQuestion>
            <br/>
            <br/>
            <StepButton
                onClick={() => {
                    this.submitRequirements();
                }}
            >
                Submit
            </StepButton>
            <StepButton
                color={"secondary"}
                onClick={() => {
                    this.backStep(StepKey.CAPTURE_DOCUMENTS)
                }}
            >
                Back
            </StepButton>
        </Fragment>
    }

    renderFinalStep() {
        return <Fragment>
            <StepQuestion>
                Your information has been submitted successfully
            </StepQuestion>
        </Fragment>
    }
}